// In-memory, account-bound command handoff. Reloading cannot replay a start.
let pending = null;
const consumed = new Set();

export function offerPart3Command(envelope, ownerId) {
  const value = envelope?.dispatch_result;
  if (envelope?.specialist_id !== "ui_part3_start" || value?.outcome !== "part3_start"
      || !ownerId || typeof value.command_id !== "string"
      || !/^[a-f0-9-]{36}$/i.test(value.command_id) || consumed.has(value.command_id)) return false;
  pending = { commandId: value.command_id, ownerId: String(ownerId),
    pupilName: typeof value.pupil_name === "string" ? value.pupil_name.slice(0, 160) : "", createdAt: Date.now() };
  return true;
}

export function takePart3Command(ownerId) {
  const value = pending;
  pending = null;
  if (!value || value.ownerId !== String(ownerId) || Date.now() - value.createdAt > 60000 || consumed.has(value.commandId)) return null;
  consumed.add(value.commandId);
  return value;
}
